import { User } from "../Model/User";
import { UserRepository } from "../Repository/UserRepository";

export interface CreateUserUseCase {
  invoke: (data: User) => Promise<boolean>;
}

export class CreateUser implements CreateUserUseCase {

  private userRepo: UserRepository;

  constructor(_userRepo: UserRepository) {
    this.userRepo = _userRepo;
  }

  async invoke(data: User){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.userRepo.createusers(data);
    return created;
  }
}